import './navbar.scss';

import { faTimes, faUser } from '@fortawesome/free-solid-svg-icons';
import { AuthService } from '@skinsoft/auth';
import { selectors, User } from '@skinsoft/auth';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { Touchable } from '@skinsoft/ui';
import { Component } from 'vue-property-decorator';

import { ContextMenuModal } from './context-menu-modal';

@Component({
    components: {
        sContextMenuModal: ContextMenuModal,
        sTouchable: Touchable,
    },
    template: require('./navbar.html'),
})
export class Navbar extends ReactiveVue {
    public $authService: AuthService;

    public $refs: {
        modal: ContextMenuModal;
        navbar: HTMLElement;
    };

    public user: User | null = null;
    public userIcon = faUser;
    public logOutIcon = faTimes;
    public userSelectors = selectors;

    public created() {
        this.subscribeTo(this.$authService.waitForUser$(), this.onUser);
    }

    public logOut() {
        if (!confirm(this.$t('navbar.logout') as string)) {
            return;
        }

        return this.$authService.logOut();
    }

    public onTouchTimed = () => {
        this.$refs.modal.open();
    };

    private onUser(user: User | null) {
        this.user = user;
    }
}
